import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="hero">
      <div className="hero-content">
        <h1 className="hero-title">Find Your Perfect Apartment with Comparent</h1>
        <p className="hero-subtitle">
          Smart apartment hunting powered by price tracking and prediction technology
        </p>
        <div className="hero-features">
          <div className="feature">
            <h3>Price Tracking</h3>
            <p>Monitor rental prices over time to spot the best deals</p>
          </div>
          <div className="feature">
            <h3>Price Prediction</h3>
            <p>Get insights on future price trends to make informed decisions</p>
          </div>
          <div className="feature">
            <h3>Best Deals</h3>
            <p>Never overpay for your next apartment</p>
          </div>
        </div>
        <button className="cta-button" onClick={() => navigate('/search')}>
          Start Your Search
        </button>
      </div>
    </div>
  );
};

export default Hero; 